/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".exampleCheckbox_b40201c5{margin:10px 0}.exampleLabel_b40201c5{margin:10px 0}\n"}]);
export const exampleCheckbox = "exampleCheckbox_b40201c5";
export const exampleLabel = "exampleLabel_b40201c5";